<template lang='pug'>
//- Side-Effect-Page
div(:class='$style[`cc-side-effect-setup`]')
  div(:class='$style[`cc-side-effect-setup-block`]')
    div(:class='$style[`cc-side-effect-setup-wrap`]')
      div(:class='$style[`cc-side-effect-setup-banner`]')
        figure(:class='$style[`cc-side-effect-setup-banner-wrap`]')

      div(v-if='!showFormSetup' :class='$style[`cc-side-effect-setup-need-login`]')
        button.font-medium.btn-extra(
          tabindex='0' aria-label='開始使用'
          :class='$style[`cc-side-effect-setup-startup`]'
          @click='handleClickToStartEPro') 👉 開始使用

        span(:class='$style[`cc-side-effect-setup-need-login-tips`]')
          strong ePRO（Electronic Patient-Reported Outcomes）
          != '是患者利用電子方式自我記錄和回報健康狀態，提供即時、準確的症狀追蹤，讓醫療團隊實時監控，優化治療計劃與提高生活品質。'

        div(:class='$style[`cc-side-effect-setup-feature`]')
          //- header.font-medium(:class='$style[`cc-side-effect-setup-feature-title`]') 專屬「醫抗癌」的功能
          ul(:class='$style[`cc-feature-wrap-ul`]')
            li(:class='$style[`cc-feature-wrap-li`]')
              //- figure(:class='$style[`cc-feature-wrap-li-img`]')
              //-   IconConsultant(:size='60')
              div(:class='$style[`cc-feature-wrap-li-info`]')
                span.font-medium(:class='$style[`cc-feature-wrap-li-title`]') 記錄癌症副作用
                  //- div.border-grey(:class='$style[`cc-feature-wrap-li-tips`]') 免費使用
                //- span.font-medium(:class='$style[`cc-feature-wrap-li-info`]')!= '建立病歷資料後，即可開始記錄副作用症狀，建議每週至少2次，每次記錄還能累積C幣點數。'

                //- div(:class='$style[`cc-feature-wrap-li-controller`]')
                //-   button.btn-extra(
                //-     tabindex='0' aria-label='了解更多關於副作用記錄'
                //-     :class='$style[`cc-feature-wrap-li-info-btn`]'
                //-     @click='handleClickToShowPointTutorial(`se`)')
                //-     span 了解更多
                  //- button.font-medium(
                  //-   tabindex='0' aria-label='C幣是什麼？'
                  //-   :class='$style[`cc-feature-wrap-li-info-coin`]'
                  //-   @click='handleClickToShowPointTutorial(`point`)')
                  //-   IconCcoin(:size='22')
                  //-   span 幣是什麼？

            li(:class='$style[`cc-feature-wrap-li`]')
              div(:class='$style[`cc-feature-wrap-li-info`]')
                span.font-medium(:class='$style[`cc-feature-wrap-li-title`]') Dr.Cell AI 執行健檢預測
                  //- div.border-grey(:class='$style[`cc-feature-wrap-li-tips`]') 免費使用
                //- span.font-medium(:class='$style[`cc-feature-wrap-li-info`]')!= '建立病歷資料後，即可開始記錄副作用症狀，建議每週至少2次，每次記錄還能累積C幣點數。'

                //- div(:class='$style[`cc-feature-wrap-li-controller`]')
                //-   button.btn-extra(
                //-     tabindex='0' aria-label='了解更多關於副作用記錄'
                //-     :class='$style[`cc-feature-wrap-li-info-btn`]'
                //-     @click='handleClickToShowPointTutorial(`se`)')
                //-     span 了解更多
                  //- button.font-medium(
                  //-   tabindex='0' aria-label='C幣是什麼？'
                  //-   :class='$style[`cc-feature-wrap-li-info-coin`]'
                  //-   @click='handleClickToShowPointTutorial(`point`)')
                  //-   IconCcoin(:size='22')
                  //-   span 幣是什麼？

            li(:class='$style[`cc-feature-wrap-li`]')
              div(:class='$style[`cc-feature-wrap-li-info`]')
                span.font-medium(:class='$style[`cc-feature-wrap-li-title`]') 線上諮詢多位醫護
                  //- div.border-gradient(:class='$style[`cc-feature-wrap-li-tips`]') VIP會員限定
                //- span.font-medium(:class='$style[`cc-feature-wrap-li-info`]')!= '利用線上諮詢室與醫師建立私人聊天室，一對一互動。只要養成每週記錄副作用習慣，醫師還會主動給予綜合改善建議喔！'
                //- div(:class='$style[`cc-feature-wrap-li-controller`]')
                //-   button.btn-extra(
                //-     tabindex='0' aria-label='了解更多關於副作用記錄'
                //-     :class='$style[`cc-feature-wrap-li-info-btn`]'
                //-     @click='handleClickToShowPointTutorial(`consult`)')
                //-     span 了解更多

            li(:class='$style[`cc-feature-wrap-li`]')
              div(:class='$style[`cc-feature-wrap-li-info`]')
                span.font-medium(:class='$style[`cc-feature-wrap-li-title`]') 診斷報告翻譯解說
                  //- div.border-grey(:class='$style[`cc-feature-wrap-li-tips`]') 免費使用
                //- span.font-medium(:class='$style[`cc-feature-wrap-li-info`]')!= '健康存摺內的英文診斷報告看不懂？使用翻譯解說取得比Google翻譯更好的內容（需消耗C幣使用翻譯），還可以保存翻譯紀錄，反覆瀏覽。'
                //- div(:class='$style[`cc-feature-wrap-li-controller`]')
                //-   button.btn-extra(
                //-     tabindex='0' aria-label='了解更多關於副作用記錄'
                //-     :class='$style[`cc-feature-wrap-li-info-btn`]'
                //-     @click='handleClickToShowPointTutorial(`translator`)')
                //-     span 了解更多


            li(:class='$style[`cc-feature-wrap-li`]')
              div(:class='$style[`cc-feature-wrap-li-info`]')
                span.font-medium(:class='$style[`cc-feature-wrap-li-title`]') 個人化精準醫療指引

            li(:class='$style[`cc-feature-wrap-li`]')
              div(:class='$style[`cc-feature-wrap-li-info`]')
                span.font-medium(:class='$style[`cc-feature-wrap-li-title`]') 病患個案管理後台

            li(:class='$style[`cc-feature-wrap-li`]')
              div(:class='$style[`cc-feature-wrap-li-info`]')
                span.font-medium(:class='$style[`cc-feature-wrap-li-title`]') 學習抗癌衛教知識

          ul(:class='$style[`cc-feature-wrap-ul-tip`]')
            li(:class='$style[`cc-feature-wrap-li-tip`]') * 本功能提供癌症醫療輔助諮詢服務，並非正規治療，如有嚴重症狀請務必至醫院掛號看診進行治療。
            li(:class='$style[`cc-feature-wrap-li-tip`]') * 為向您提供更完善的個人化服務，本服務可能會蒐集、處理和利用您的個人資料。
            
      div(v-else :class='$style[`cc-side-effect-setup-content`]')
        div(:class='$style[`cc-side-effect-setup-board`]')
          div(:class='$style[`cc-side-effect-setup-profile`]')

            div.font-bold(:class='$style[`cc-side-effect-setup-welcome`]') 請先建立病歷資料
              //- != '請先建立您的病歷資料'
              //- //- span!= ' 建立您的病歷資料'

          //- div(v-if='loginProfile.verified === `yes`' :class='$style[`cc-side-effect-setup-panel`]')
          //-   div(:class='[$style[`cc-side-effect-setup-verify`], $style[`cc-is-verify`]]')
          //-     div(:class='$style[`cc-side-effect-setup-verify-icon`]')
          //-       IconConfirm(:size='16' :color='`#fff`')
          //-     span!= '已認證會員'
            
          //- div(v-else :class='$style[`cc-side-effect-setup-panel`]')
          //-   div(:class='$style[`cc-side-effect-setup-verify`]')
          //-     div(:class='$style[`cc-side-effect-setup-verify-icon`]')
          //-       IconConfirm(:size='16' :color='`#fff`')
          //-     span!= '未認證會員'
          //-   button(
          //-     title='驗證帳號'
          //-     tabindex='0'
          //-     aria-label='驗證帳號'
          //-     :class='$style[`cc-side-effect-setup-verify-btn`]'
          //-     @click='sendVerifiedEmail')!= '驗證帳號'
          
        //- 表單區
        div(:class='$style[`cc-side-effect-setup-form`]')
          div(:class='$style[`cc-side-effect-setup-tips`]') 本ePRO遠距照護服務的所有電子數據僅限本人瀏覽，繼續使用即代表您同意與Cancell分享隱私資訊，您的資料將會被嚴格保護。
          
          div(:class='$style[`cc-side-effect-setup-form-wrap`]')
            //- 病患關係
            div(:class='$style[`cc-side-effect-setup-form-list`]')
              div(:class='[$style[`cc-side-effect-setup-form-list-title`], $style[`need-fill`]]')
                span!= '病患關係'
              div(:class='$style[`cc-side-effect-setup-form-area`]')
                SelectModel(
                  v-model='formConfig.role'
                  title='請選擇身份'
                  style='width: 210px'
                  :class='$style[`cc-select-area`]'
                  :placehold='`身份別`'
                  :optionList='[`我是照顧者`, `病患本人`]'
                  :errorValue='formVerify.roleError'
                  @clearErrorMsg="(value) => {this.formVerify.role = value}")

            //- 身高
            div(:class='$style[`cc-side-effect-setup-form-list`]')
              div(:class='[$style[`cc-side-effect-setup-form-list-title`], $style[`need-fill`]]')
                span!= '身高(Cm)'
              div(:class='$style[`cc-side-effect-setup-form-area`]')
                Inputer(
                  v-model.trim='formConfig.height'
                  title='請填寫身高'
                  style='width: 100px'
                  :class='$style[`cc-input-area`]'
                  :resetButton='false'
                  :placehold='`168`'
                  :errorValue='formVerify.heightError'
                  :errorRegex='formVerify.heightRegexError'
                  :errorRegexInfo='formVerify.heightErrorLog'
                  @clearErrorMsg="(value) => {this.formVerify.heightError = value[0]; this.formVerify.heightRegexError = value[1];}")
        
            //- 體重
            div(:class='$style[`cc-side-effect-setup-form-list`]')
              div(:class='[$style[`cc-side-effect-setup-form-list-title`], $style[`need-fill`]]')
                span!= '體重(Kg)'
              div(:class='$style[`cc-side-effect-setup-form-area`]')
                Inputer(
                  v-model='formConfig.weight'
                  title='請填寫體重'
                  style='width: 100px'
                  :class='$style[`cc-input-area`]'
                  :resetButton='false'
                  :placehold='`65`'
                  :errorValue='formVerify.weightError'
                  :errorRegex='formVerify.weightRegexError'
                  :errorRegexInfo='formVerify.weightErrorLog'
                  @clearErrorMsg="(value) => {this.formVerify.weightError = value[0]; this.formVerify.weightRegexError = value[1];}")

            //- 出生日期
            div(:class='$style[`cc-side-effect-setup-form-list`]')
              div(:class='[$style[`cc-side-effect-setup-form-list-title`], $style[`need-fill`]]')
                span!= '出生日期'
              div(:class='$style[`cc-side-effect-setup-form-area`]')
                date-picker(
                  v-model='formConfig.dateBirth'
                  placeholder='選擇日期'
                  valueType='format'
                  format='YYYY.MM.DD'
                  @pick='dateBirthKillError'
                  :class='[`date-picker`, $style[formVerify.dateBirthError ? `cc-datepicker-error` : ``]]')
                  template(v-slot:header="{ emit }")
                    button(
                      v-for='(items, index) in datePickerYearShortCut'
                      :title='`選擇${items.text}`' tabindex='0' :aria-label='`選擇${items.text}`'
                      class="mx-btn mx-btn-text" @click="emit(items.onClick())") {{ items.text }}
                

             

            //- 聯絡手機
            //- div(:class='$style[`cc-side-effect-setup-form-list`]')
            //-   div(:class='[$style[`cc-side-effect-setup-form-list-title`], $style[`need-fill`]]')
            //-     span!= '聯絡手機'
            //-   div(:class='$style[`cc-side-effect-setup-form-area`]')
            //-     Inputer(
            //-       v-model.trim='formConfig.phone'
            //-       title='請填寫手機'
            //-       style='width: 210px'
            //-       :class='$style[`cc-input-area`]'
            //-       :resetButton='false'
            //-       :placehold='`0912345678`'
            //-       :defaultValue='loginProfile.phone'
            //-       :errorValue='formVerify.phoneError'
            //-       :errorRegex='formVerify.phoneRegexError'
            //-       :errorRegexInfo='formVerify.phoneErrorLog'
            //-       @clearErrorMsg="(value) => {this.formVerify.phoneError = value[0]; this.formVerify.phoneRegexError = value[1];}")

            //- 罹患癌症
            div(:class='$style[`cc-side-effect-setup-form-list`]')
              div(:class='[$style[`cc-side-effect-setup-form-list-title`], $style[`need-fill`]]')
                span!= '罹患癌症'
              div(:class='$style[`cc-side-effect-setup-form-area`]')
                Inputer(
                  v-model='formConfig.cancertype'
                  title='請選擇罹患癌症'
                  style='width: 300px;'
                  :class='$style[`cc-input-area`]'
                  :resetButton='false'
                  :placehold='`範例：肺腺癌`'
                  :errorValue='formVerify.cancertypeError'
                  @clearErrorMsg="(value) => {this.formVerify.cancertypeError = value[0];}")
                  
                //- SelectModel(
                //-   v-model='formConfig.cancertype'
                //-   title='請選擇罹患癌症'
                //-   style='width: 210px'
                //-   :class='$style[`cc-select-area`]'
                //-   :placehold='`癌症別`'
                //-   :optionList='CANCER_TYPE'
                //-   :errorValue='formVerify.cancertypeError'
                //-   @clearErrorMsg="(value) => {this.formVerify.cancertypeError = value}")

                //- Inputer(
                //-   v-if='formConfig.cancertype === `填寫其他`'
                //-   v-model='formConfig.cancertypeSpecial'
                //-   title='某某癌'
                //-   style='width: 210px; margin-left: 10px'
                //-   :class='$style[`cc-input-area`]'
                //-   :resetButton='false'
                //-   :placehold='`某某癌`'
                //-   :errorValue='formVerify.cancertypeSpecialError'
                //-   @clearErrorMsg="(value) => {this.formVerify.cancertypeSpecialError = value[0];}")

            //- 癌症期數
            div(:class='$style[`cc-side-effect-setup-form-list`]')
              div(:class='[$style[`cc-side-effect-setup-form-list-title`], $style[`need-fill`]]')
                span!= '癌症期數'
              div(:class='$style[`cc-side-effect-setup-form-area`]')
                SelectModel(
                  v-model='formConfig.cancerlevel'
                  title='請選擇癌症期數'
                  style='width: 210px'
                  :class='$style[`cc-select-area`]'
                  :placehold='`期數`'
                  :optionList='[`原位癌`, `一`, `二`, `三`, `四`]'
                  :errorValue='formVerify.cancerlevelError'
                  @clearErrorMsg="(value) => {this.formVerify.cancerlevelError = value}")

            //- 初次診斷
            div(:class='$style[`cc-side-effect-setup-form-list`]')
              div(:class='[$style[`cc-side-effect-setup-form-list-title`], $style[`need-fill`]]')
                span!= '初次診斷'
              div(:class='$style[`cc-side-effect-setup-form-area`]')
                date-picker(
                  v-model='formConfig.dateFirstDiagnose'
                  placeholder='選擇日期'
                  valueType='format'
                  format='YYYY.MM.DD'
                  @pick='dateFirstDiagnoseKillError'
                  :class='[`date-picker`, $style[formVerify.dateFirstDiagnoseError ? `cc-datepicker-error` : ``]]')
                  template(v-slot:header="{ emit }")
                    button(
                      v-for='(items, index) in datePickerMonthShortCut'
                      :title='`選擇${items.text}`' tabindex='0' :aria-label='`選擇${items.text}`'
                      class="mx-btn mx-btn-text" @click="emit(items.onClick())") {{ items.text }}
        

            //- 疾病狀態
            div(:class='$style[`cc-side-effect-setup-form-list`]')
              div(:class='[$style[`cc-side-effect-setup-form-list-title`], $style[`need-fill`]]')
                span!= '疾病狀態'
              div(:class='$style[`cc-side-effect-setup-form-area`]')
                SelectModel(
                  v-model='formConfig.nowstatus'
                  title='請選擇目前疾病狀態'
                  style='width: 210px'
                  :class='$style[`cc-select-area`]'
                  :placehold='`目前狀態`'
                  :optionList='[`新診斷確診`, `復發轉移`]'
                  :errorValue='formVerify.nowstatusError'
                  @clearErrorMsg="(value) => {this.formVerify.nowstatusError = value}")

            //- 治療醫院
            div(:class='$style[`cc-side-effect-setup-form-list`]')
              div(:class='[$style[`cc-side-effect-setup-form-list-title`], $style[`need-fill`]]')
                span!= '治療醫院'
              div(:class='$style[`cc-side-effect-setup-form-area`]')
                Inputer(
                  v-model='formConfig.hospital'
                  title='治療醫院'
                  style='width: 300px'
                  :class='$style[`cc-input-area`]'
                  :resetButton='false'
                  :placehold='`長庚醫院台北院區`'
                  :errorValue='formVerify.hospitalError'
                  @clearErrorMsg="(value) => {this.formVerify.hospitalError = value[0];}")
            
            //- 目前治療藥物名
            div(:class='$style[`cc-side-effect-setup-form-list`]')
              div(:class='[$style[`cc-side-effect-setup-form-list-title`], $style[`need-fill`]]')
                span!= '目前治療藥物名'
              div(:class='$style[`cc-side-effect-setup-form-area`]')
                Inputer(
                  v-model='formConfig.medicine'
                  title='目前治療藥物名'
                  style='width: 300px'
                  :class='$style[`cc-input-area`]'
                  :resetButton='false'
                  :placehold='`沒有請填無`'
                  :errorValue='formVerify.medicineError'
                  @clearErrorMsg="(value) => {this.formVerify.medicineError = value[0];}")

            //- 已做過治療/日期
            div(:class='[$style[`cc-side-effect-setup-form-list`], $style[`align-top`], $style[`full-width`]]')
              div(:class='$style[`cc-side-effect-setup-form-list-title`]' )
                span!= '曾做過的治療/日期'
              div(:class='[$style[`cc-side-effect-setup-form-area`], $style[`cc-side-effect-setup-form-area-beforeTreatment`]]')
                nav(v-for='items, index in formConfig.beforeTreatment' :key='index' :class='$style[`cc-side-effect-setup-form-area-block`]')
                  SelectModel(
                    v-model='formConfig.beforeTreatment[index].type'
                    title='請選擇曾做過的治療'
                    style='width: 150px; margin-right: 10px; margin-bottom: 5px;'
                    :class='$style[`cc-select-area`]'
                    :placehold='`請選擇`'
                    :optionList='cancerTreatmentList')
                  date-picker(
                    v-model='formConfig.beforeTreatment[index].date'
                    class='date-picker'
                    placeholder='選擇日期'
                    valueType='format'
                    format='YYYY.MM.DD'
                    style='margin-bottom: 5px;')
                    template(v-slot:header="{ emit }")
                      button(
                        v-for='(items, index) in datePickerMonthShortCut'
                        :title='`選擇${items.text}`' tabindex='0' :aria-label='`選擇${items.text}`'
                        class="mx-btn mx-btn-text" @click="emit(items.onClick())") {{ items.text }}
                   
                  button(
                    tabindex='0' aria-label='刪除'
                    :class='$style[`cc-multi-form-reset`]'
                    @click='multiFormResetClick(index)')
                    IconClose(:size='16' :color='`#98A1A1`')
                    != '刪除'

                div(
                  :class='$style[`cc-side-effect-setup-form-area-btn`]'
                  @click='appendNewTreatment')!= '+ 新增其他'

            //- 目前做的治療
            div(:class='[$style[`cc-side-effect-setup-form-list`], $style[`full-width`]]')
              div(:class='$style[`cc-side-effect-setup-form-list-title`]')
                span!= '目前做的治療'
              div(:class='$style[`cc-side-effect-setup-form-area`]')
                SelectModel(
                  v-model='formConfig.nowTreatment'
                  title='請選擇目前做的治療'
                  style='width: 150px;'
                  :class='$style[`cc-select-area`]'
                  :placehold='`請選擇`'
                  :optionList='cancerTreatmentList')

            //- 其他疾病
            div(:class='[$style[`cc-side-effect-setup-form-list`], $style[`align-top`], $style[`full-width`]]')
              div(:class='$style[`cc-side-effect-setup-form-list-title`]')
                span!= '其他疾病'
              div(:class='$style[`cc-side-effect-setup-form-area`]')
                CheckBox2(style='margin: 5px 18px 5px 0px;' :labelText='`糖尿病`' @sendCheckStatus='watchCheckBoxUpdate')
                CheckBox2(style='margin: 5px 18px 5px 0px;' :labelText='`高血壓`' @sendCheckStatus='watchCheckBoxUpdate')
                CheckBox2(style='margin: 5px 18px 5px 0px;' :labelText='`腎臟病`' @sendCheckStatus='watchCheckBoxUpdate')
                CheckBox2(style='margin: 5px 18px 5px 0px;' :labelText='`肝硬化`' @sendCheckStatus='watchCheckBoxUpdate')
                CheckBox2(style='margin: 5px 18px 5px 0px;' :labelText='`中風`' @sendCheckStatus='watchCheckBoxUpdate')
                CheckBox2(style='margin: 5px 18px 5px 0px;' :labelText='`心臟病`' @sendCheckStatus='watchCheckBoxUpdate')


        //- 控制器
        div(:class='$style[`cc-side-effect-setup-control`]')
          button.btn-confirm-extra.bg-normal-theme(
            title='建立資料'
            tabindex='0'
            aria-label='建立資料'
            :class='$style[`cc-side-effect-setup-control-btn`]'
            @click='handleCreatePersonalProfileProcess')!= '建立資料'

</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/zh-tw';

import Inputer from '../common/Input';
import SelectModel from '../common/SelectModel';
import CheckBox2 from '../common/Checkbox2';

import IconClose from '../../icon/Close';
import IconConfirm from '../../icon/Confirm';
import IconConsultant from '../../icon/Consultant';
import IconSearch from '../../icon/Search';
import IconTranslate from '../../icon/Translate';
import IconCcoin from '../../icon/Ccoin';
import IconDialog from '../../icon/Dialog';
import IconFeature from '../../icon/Feature';

import { debounce } from 'debounce';

import {
  getCurrentDate,
  // getSendVerifiedMail,
  putCheckUserSubscribe,
  putUpdateSideEffectProfile,
  // putChatRoomCreate,
} from '../../../js/restapi';

export default {
  metaInfo() {
    return {
      title: '醫抗癌',
      titleTemplate: '%s | Cancell 醫抗癌',
      meta: [{
        name: 'og:url',
        content: 'https://cancell.tw/sideeffect/setup',
      }],
      link: [{
        rel: 'canonical',
        href: 'https://cancell.tw/sideeffect/setup',
      }],
    };
  },

  components: {
    DatePicker,
    Inputer,
    SelectModel,
    CheckBox2,
    IconConfirm,
    IconClose,
    IconConsultant,
    IconTranslate,
    IconSearch,
    IconDialog,
    IconFeature,
    IconCcoin,
  },

  created() {
    if (this.loginStatus) {
      // this.changePopBoxStatus({
      //   active: true,
      //   include: 'login',
      // });

      if (this.loginProfile.user_type === 'normal') {
        if (this.loginProfile.sideeffect === 'yes') {
          this.$router.replace({
            name: 'effect-record',
          }).catch(() => true);
        }

        // if (this.loginProfile.phone) {
        //   this.formConfig.phone = this.loginProfile.phone;
        // }
      } else {
        this.$router.push({
          name: 'index',
        }).catch(() => true);

        this.changePopBoxStatus({
          active: true,
          include: 'warnNotDoctor',
        });
      }
    }
  },

  data() {
    return {
      showFormSetup: false,
      formConfig: {
        role: '',
        height: '',
        weight: '',
        phone: '',
        cancertype: '',
        // cancertypeSpecial: '',
        cancerlevel: '',
        nowstatus: '',
        hospital: '',
        medicine: '',
        dateBirth: '',
        dateFirstDiagnose: '',
        beforeTreatment: [{type: '', date: ''}],
        nowTreatment: '',
        otherdisease: [],
      },
      formVerify: {
        roleError: false,

        heightError: false,
        heightRegexError: false,
        heightErrorLog: '限3位數字',

        weightError: false,
        weightRegexError: false,
        weightErrorLog: '限3位數字',

        phoneError: false,
        phoneRegexError: false,
        phoneErrorLog: '格式錯誤',

        cancertypeError: false,
        // cancertypeSpecialError: false,
        cancerlevelError: false,
        nowstatusError: false,
        hospitalError: false,
        medicineError: false,
        dateBirthError: false,
        dateFirstDiagnoseError: false,
      },
      verifyAllPass: true,
    };
  },

  methods: {
    ...mapActions({
      updateUserProfileSideEffect: 'user/userUpdateProfileSideEffect',
      updateProfileSideEffectPersonal: 'user/userUpdateProfileSideEffectPersonal',
    }),

    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changePopYoutubeStatus: 'global/POPYOUTUBE_STATUS',
      changePopShowTutorialStatus: 'global/POPSHOW_TUTORIAL_STATUS',
      changeUserSubscribe: 'user/USER_CHECK_SUBSCRIBE',
    }),

    youTubePopOutClick(ytLink) {
      this.changePopYoutubeStatus({
        active: true,
        link: ytLink,
      });
    },

    handleClickToStartEPro() {
      if (!this.loginStatus) {
        // this.$router.push({
        //   name: 'effect-demo',
        // }).catch(() => true);
        this.changePopBoxStatus({
          active: true,
          include: 'login',
        });
      } else {
        this.showFormSetup = true;
      }
    },

    handleClickToShowPointTutorial(feature) {
      this.changePopShowTutorialStatus({
        active: true,
        include: feature,
      });
    },

    appendNewTreatment() {
      this.formConfig.beforeTreatment.push({type: '', date: ''});
    },

    multiFormResetClick(index) {
      this.formConfig.beforeTreatment.splice(index, 1);
    },

    analyzeBeforeTreatmentEmpty(arr) {
      let newArr = [];
      arr.map((x) => {
        if (x.type) {
          newArr.push(x);
        }
      });
      return JSON.stringify(newArr);
    },

    // sendVerifiedEmail() {
    //   // const jwtAccess = JSON.parse(this.authJwtToken).a;
      
    //   this.changePopBoxStatus({
    //     active: true,
    //     include: 'sendVerify',
    //   });

    //   // getSendVerifiedMail(`?mail=${this.loginProfile.email}`, {
    //   //   headers: {
    //   //     'content-Type': 'application/json',
    //   //     // Authorization: `Bearer ${jwtAccess}`,
    //   //   },
    //   // })
    //   //   .then((/* response */) => {
    //   //     // console.log(response.data.results);
    //   //   })
    //   //   .catch((error) => {
    //   //     console.log('Axios getSendVerifiedMail Error', error.response);
    //   //     if (error.response.status === 401) {
    //   //       this.changePopBoxStatus({
    //   //         active: true,
    //   //         include: 'relogin',
    //   //       });
    //   //     }
    //   //   });
    //   // this.changePopBoxStatus({
    //   //   active: true,
    //   //   include: 'sendVerified',
    //   // });
    //   // setTimeout(() => {
    //   //   // 關閉 POPBOX
    //   //   this.changePopBoxStatus({
    //   //     active: false,
    //   //     include: '',
    //   //   });
    //   // }, this.POP_DURATION);
    // },

    watchCheckBoxUpdate(value, text) {
      if (value === 'checked') {
        this.formConfig.otherdisease.push(text);
      } else {
        const filterArray = this.formConfig.otherdisease.filter((e) => e !== text);
        this.formConfig.otherdisease = filterArray;
      }
      // this.filterConfig.feature = JSON.stringify(this.featureChoose).replace(/\[|]/g, '').replace(/["']/g, '');
      console.log('this.formConfig.otherdisease', this.formConfig.otherdisease);
    },

    dateBirthKillError() {
      this.formVerify.dateBirthError = false;
    },

    dateFirstDiagnoseKillError() {
      this.formVerify.dateFirstDiagnoseError = false;
    },

    axiosCreateSideEffectProfile() {
      if (!this.verifyAllPass) { return; }

       getCurrentDate('')
        .then((res) => {
          // const jwtAccess = JSON.parse(this.authJwtToken).a;
          const CONFIG = {
            headers: {
              'content-Type': 'application/json',
              // Authorization: `Bearer ${jwtAccess}`,
            },
          };

          const POST_DATA = {
            auth_id: `${this.loginDjangoId}`,
            phone: `${this.formConfig.phone}`,
            birthday: `${this.formConfig.dateBirth}`,
            pr_role: `${this.formConfig.role}`,
            pr_height: `${this.formConfig.height}`,
            pr_weight: `${this.formConfig.weight}`,
            pr_cancertype: this.formConfig.cancertype === `填寫其他` ? `${this.formConfig.cancertypeSpecial}` : `${this.formConfig.cancertype}`,
            pr_cancerperiod: `${this.formConfig.cancerlevel}`,
            // pr_subtype: "",
            pr_firstdiagnose: `${this.formConfig.dateFirstDiagnose}`,
            pr_nowstatus: `${this.formConfig.nowstatus}`,
            pr_hospital: `${this.formConfig.hospital}`,
            pr_medicine: `${this.formConfig.medicine}`,
            pr_beforetreatment: this.analyzeBeforeTreatmentEmpty(this.formConfig.beforeTreatment),
            pr_nowtreatment: `${this.formConfig.nowTreatment}`,
            pr_otherdisease: `${this.formConfig.otherdisease}`,
            pr_joindate: `${res.data}`,
          };
          console.log('POST_DATA', POST_DATA);

          putUpdateSideEffectProfile('', POST_DATA, CONFIG)
            .then((res) => {
              console.log('建立副作用基本資料 Success', res, this.$route.query.b);
              this.changePopBoxStatus({
                active: true,
                include: 'createConfirm',
              });

              if (this.$route.query.b) {
                this.$router.replace({
                  path: `/binder?b=${this.$route.query.b}`,
                }).catch(() => true);
              } else {
                this.$router.replace({
                  name: 'effect-consult',
                }).catch(() => true);
              }

              this.updateUserProfileSideEffect('yes');
              this.updateProfileSideEffectPersonal(`${res.data.id}`);

              putCheckUserSubscribe('', {auth_id: `${this.loginDjangoId}`}, {
                headers: {
                  'content-Type': 'application/json',
                  // Authorization: `Bearer ${jwtAccess}`,
                }})
                .then((res) => {
                  this.changeUserSubscribe(res.data.subscribe);
                })
                .catch((err) => {
                  console.log('建立聊天室 Error', err);
                })

              setTimeout(() => {
                this.changePopBoxStatus({
                  active: false,
                  include: '',
                });
              }, this.POP_DURATION);
            })
            .catch((err) => {
              console.log('建立副作用基本資料 Error', err);
            })
            
        })
        .catch((err) => {
          console.log('getCurrentDate Error', err);
        })
    },

    handleFormsCheckToPass() {
      this.verifyAllPass = true;
      // 姓氏與姓名不是中文
      // const chinesePattern = new RegExp(/[\u4e00-\u9fa5]$/);
      const heightWeightPattern = new RegExp(/^[0-9]{2,3}$/);
      // const phonePattern = new RegExp(/^09\d{8}$/);
      // 驗證角色欄位為空
      if (!this.formConfig.role) {
        this.formVerify.roleError = true;
        this.verifyAllPass = false;
      }

      // 驗證身高欄位為空
      if (this.formConfig.height) {
        if (!this.formConfig.height.match(heightWeightPattern)) {
          this.formVerify.heightError = true;
          this.formVerify.heightRegexError = true;
          this.verifyAllPass = false;
        }
      } else {
        this.formVerify.heightError = true;
        this.verifyAllPass = false;
      }

      // 驗證體重欄位為空
      if (this.formConfig.weight) {
        if (!this.formConfig.weight.match(heightWeightPattern)) {
          this.formVerify.weightError = true;
          this.formVerify.weightRegexError = true;
          this.verifyAllPass = false;
        }
      } else {
        this.formVerify.weightError = true;
        this.verifyAllPass = false;
      }

      // 驗證生日欄位為空
      if (!this.formConfig.dateBirth) {
       this.formVerify.dateBirthError = true;
        this.verifyAllPass = false;
      }

      // 驗證手機欄位為空
      // if (this.formConfig.phone) {
      //   if (!this.formConfig.phone.match(phonePattern)) {
      //     this.formVerify.phoneError = true;
      //     this.formVerify.phoneRegexError = true;
      //     this.verifyAllPass = false;
      //   }
      // } else {
      //   this.formVerify.phoneError = true;
      //   this.verifyAllPass = false;
      // }

      // 驗證癌症別欄位為空
      if (!this.formConfig.cancertype) {
        this.formVerify.cancertypeError = true;
        this.verifyAllPass = false;
      }
      // else if (this.formConfig.cancertype === '填寫其他') {
      //   if (!this.formConfig.cancertypeSpecial) {
      //     this.formVerify.cancertypeSpecialError = true;
      //     this.verifyAllPass = false;
      //   }
      // }

      // 驗證癌症期數欄位為空
      if (!this.formConfig.cancerlevel) {
       this.formVerify.cancerlevelError = true;
        this.verifyAllPass = false;
      }

      // 驗證初次診斷欄位為空
      if (!this.formConfig.dateFirstDiagnose) {
       this.formVerify.dateFirstDiagnoseError = true;
        this.verifyAllPass = false;
      }

      // 驗證目前狀態欄位為空
      if (!this.formConfig.nowstatus) {
       this.formVerify.nowstatusError = true;
        this.verifyAllPass = false;
      }

      // 驗證治療醫院欄位為空
      if (!this.formConfig.hospital) {
       this.formVerify.hospitalError = true;
        this.verifyAllPass = false;
      }

      // 驗證治療藥物欄位為空
      if (!this.formConfig.medicine) {
       this.formVerify.medicineError = true;
        this.verifyAllPass = false;
      }
    },

    handleCreatePersonalProfileProcess: debounce(function (e) {
      this.handleCheckProgressBeforeCreate();
    }, 300),

    async handleCheckProgressBeforeCreate() {
      await this.handleFormsCheckToPass();
      await this.axiosCreateSideEffectProfile();
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      rwdType: 'global/exportRwdType',
      loginDjangoId: 'user/exportUserDjangoId',
      loginStatus: 'user/exportLoginStatus',
      loginProfile: 'user/exportUserProfile',
      // stateFlowBarFixed: 'global/exportFlowBarFixed',
      authJwtToken: 'user/exportUserJwtToken',
    }),
  },

  watch: {
    loginStatus() {
      if (this.loginStatus) {
        if (this.loginProfile.user_type === 'normal') {
          if (this.loginProfile.sideeffect === 'yes') {
            this.$router.replace({
              name: 'effect-record',
            }).catch(() => true);
          }
        } else {
          this.$router.push({
            name: 'index',
          }).catch(() => true);

          this.changePopBoxStatus({
            active: true,
            include: 'warnNotDoctor',
          });
        }
      }
    }
  },
};
</script>

<style module lang='scss'>
  @import '../../../sass/component/page/sideeffect/effectSetup.scss';
</style>
